// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".php-consent .ant-checkbox-inner{border:1px solid black !important}\n", "",{"version":3,"sources":["webpack://./src/common/new-form/primary-subscriber-consent/primary-subscriber-consent.scss"],"names":[],"mappings":"AAAA,iCACE,iCAAkC","sourcesContent":[".php-consent .ant-checkbox-inner {\n  border: 1px solid black !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
